/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { Form, FormInstance } from 'antd';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { FLEET_NAME_MAX_LENGTH } from '@/pages/FleetManagement/NewFleetWizardSteps/types';
import { Container } from '@/primitives/Container';
import { Input } from '@/primitives/Input';
import { TextArea } from '@/primitives/TextArea';

export type EditFormFields = {
  name: string;
  description: string;
};

export type NodeGroupEditFormProps = {
  form: FormInstance<EditFormFields>;
  initialName: string;
  initialDescription: string;
};

export function NodeGroupEditForm({ form, initialName, initialDescription }: NodeGroupEditFormProps) {
  const { t } = useMimicTranslation('fleets');

  return (
    <Container style={{ marginTop: '32px', width: '30%', maxWidth: '800px' }}>
      <Form
        form={form}
        layout="vertical"
        style={{ width: '100%' }}
        initialValues={{ name: initialName, description: initialDescription }}
      >
        <Form.Item label={t('form.fleetName')} name="name">
          <Input
            placeholder={t('form.fleetNamePlaceholder')}
            count={{ max: FLEET_NAME_MAX_LENGTH }}
            style={{ backgroundColor: '#ffffff' }}
          />
        </Form.Item>
        <Form.Item label={t('form.description')} name="description">
          <TextArea
            allowClear
            rows={3}
            maxLength={280}
            count={{ show: true, max: 280 }}
            style={{ backgroundColor: '#ffffff' }}
          />
        </Form.Item>
      </Form>
    </Container>
  );
}
